import { ParsedUrlQuery } from 'querystring';

/**
 * GetQueryString.
 */
export const getQueryString = (q?: string | string[]) => {
  if (!q) return '';

  if (typeof q === 'string') return q;

  return q[0];
};

/**
 * GetFormattedQuery.
 */
export const getFormattedQuery = (q: string | string[] | undefined) => {
  if (!q) {
    if (typeof q === 'string') return '';
    return q;
  }

  if (typeof q === 'string') return q;

  return q[0];
};

/**
 * ParsePurchaseURLParameters.
 */
export const parsePurchaseURLParameters = (
  query: Record<string, string> | ParsedUrlQuery,
): {
  purchase?: string;
  email?: string;
  isNewUser?: boolean;
  firstName?: string;
  lastName?: string;
  redirect?: string;
} => {
  const { purchase, p, isNewUser, r } = query as {
    purchase?: string;
    p?: string;
    isNewUser?: string;
    r?: string;
  };

  if (!p) return { purchase, redirect: r };

  try {
    const info = Buffer.from(p, 'base64').toString('utf8');
    const { email, firstName, lastName } = JSON.parse(info) as {
      email?: string;
      firstName?: string;
      lastName?: string;
    };
    return {
      purchase,
      email,
      firstName,
      lastName,
      isNewUser: isNewUser === 'true',
    };
  } catch (error) {
    return { purchase };
  }
};

const allowedPaths = ['/schedule'];

/**
 * Whitelist a path param.
 * @param path
 * @returns
 */
export const isAllowedPath = (path: string) => {
  return allowedPaths.includes(path);
};
